import {FC, ReactNode} from 'react';

export type HeaderProps = {
    children: ReactNode;
    className?: string;
    hasLeftBorderDecoration?: boolean;
};

export const H1: FC<Omit<HeaderProps, 'hasLeftBorderDecoration'>> = ({
    children,
    className,
}) => <h1 className={className}>{children}</h1>;

export const H2: FC<HeaderProps> = ({
    children,
    className,
    hasLeftBorderDecoration = true,
}) => (
    <h2 className={className}>
        {hasLeftBorderDecoration && (
            <span className="mr-2 inline-block h-5 rounded border-2 border-grey-500 align-sub" />
        )}
        {children}
    </h2>
);

export const H3: FC<Omit<HeaderProps, 'hasLeftBorderDecoration'>> = ({
    children,
    className,
}) => <h3 className={className}>{children}</h3>;

export const H4: FC<Omit<HeaderProps, 'hasLeftBorderDecoration'>> = ({
    children,
    className,
}) => <h4 className={className}>{children}</h4>;

export const H5: FC<Omit<HeaderProps, 'hasLeftBorderDecoration'>> = ({
    children,
    className,
}) => <h5 className={className}>{children}</h5>;
